module.exports = __webpack_public_path__ + "img/11.b05a8c68.jpg";